/**
 * Taking a machine away, at the foot of its Values sheet: a quiet button, saying why not when it
 * can't (not yours, collect it first), from the rules' own check (game/machines/remove.ts).
 */
import type { JSX } from 'react';

import { removeCheck, removeMachine } from '@game/machines/remove';
import { closePanel } from '@game/view/panels';
import { reasonText, t } from '@i18n/index';
import { haptic } from '@platform/haptics';
import { useGame } from '@ui/hooks';

export function RemoveRow({ tile, name }: { tile: number; name: string }): JSX.Element {
  const game = useGame();
  const check = removeCheck(game, tile);
  const reason =
    check.state === 'refused'
      ? reasonText(check.refusal)
      : check.state === 'waiting'
        ? t('reason.waiting')
        : null;
  return (
    <div className="remove-row">
      <button
        type="button"
        className="btn quiet warn small"
        data-remove="machine"
        aria-disabled={check.state !== 'ok'}
        aria-label={`${t('machine.remove-aria', { name: name.toLowerCase() })}${reason ? `: ${reason}` : ''}`}
        onClick={() => {
          if (removeMachine(game, tile)) {
            haptic('select');
            closePanel(game);
          } else haptic('refused');
        }}
      >
        {t('machine.remove')}
      </button>
      {reason && <small className="note">{reason}</small>}
    </div>
  );
}
